import { trpc } from '@tencent/tpro_rmonitor_ai_server';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { logger } from '@/infrastructure/logger';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type IGetUserHistoryQueryRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetUserHistoryQueryRsp>;
export type IGetUserHistoryQueryReq = WithTypeCast<trpc.rmonitor.ai_server.IGetUserHistoryQueryReq>;
export type IDeleteQARsp = WithTypeCast<trpc.rmonitor.ai_server.IDeleteQARsp>;
export type IDeleteQAReq = WithTypeCast<trpc.rmonitor.ai_server.IDeleteQAReq>;
export type IFeedbackRsp = WithTypeCast<trpc.rmonitor.ai_server.IFeedbackRsp>;
export type IFeedbackReq = WithTypeCast<trpc.rmonitor.ai_server.IFeedbackReq>;
export type IGetSessionListRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetSessionListRsp>;
export type IGetSessionListReq = WithTypeCast<trpc.rmonitor.ai_server.IGetSessionListReq>;
export type IGetHistoryQARsp = WithTypeCast<trpc.rmonitor.ai_server.IGetHistoryQARsp>;
export type IGetHistoryQAReq = WithTypeCast<trpc.rmonitor.ai_server.IGetHistoryQAReq>;
export type IMessage = WithTypeCast<trpc.rmonitor.ai_server.IMessage[]>;
export type IGetLatestAnalysisReq = WithTypeCast<trpc.rmonitor.ai_server.IGetLatestAnalysisReq>;
export type IGetLatestAnalysisRsp = WithTypeCast<trpc.rmonitor.ai_server.IGetLatestAnalysisRsp>;

export type IFeedbackMsgReq = WithTypeCast<trpc.rmonitor.ai_server.IFeedbackMsgReq>;
export type IFeedbackMsgRsp = WithTypeCast<trpc.rmonitor.ai_server.IFeedbackMsgRsp>;

class AiCopilotServer extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.AiCopilotService,
    });
  }

  /**
   * 获取首页提示问题
   */
  public async getPrompts(req: IGetUserHistoryQueryReq): Promise<IGetUserHistoryQueryRsp> {
    try {
      return await this.trpcPost<IGetUserHistoryQueryRsp>('GetUserHistoryQuery', req);
    } catch (e) {
      logger.error('getPrompts e:', e);
      return {
        querys: [],
      };
    }
  }

  /**
   * 删除回答用于重生成
   */
  public async deleteQA(req: IDeleteQAReq): Promise<IDeleteQARsp> {
    try {
      return await this.trpcPost<IDeleteQARsp>('DeleteQA', req);
    } catch (e) {
      logger.error('deleteQA e:', e);
      return {};
    }
  }

  /**
   * 点赞/点踩
   */
  public async feedback(req: IFeedbackReq): Promise<IFeedbackRsp> {
    try {
      return await this.trpcPost('Feedback', req);
    } catch (e) {
      logger.error('Feedback e:', e);
      return {};
    }
  }

  /**
  * 点赞/点踩
  */
  public async feedbackMsg(req: IFeedbackMsgReq): Promise<IFeedbackMsgRsp> {
    try {
      return await this.trpcPost('FeedbackMsg', req);
    } catch (e) {
      logger.error('Feedback e:', e);
      return {};
    }
  }

  /**
   * 获取历史记录
   */
  public async getHistoryQA(req: IGetHistoryQAReq): Promise<IGetHistoryQARsp> {
    try {
      return await this.trpcPost('GetHistoryQA', req);
    } catch (e) {
      logger.error('getHistoryQA e:', e);
      return {};
    }
  }

  /**
   * 获取会话历史记录
   */
  public async getSessionList(req: IGetSessionListReq): Promise<IGetSessionListRsp> {
    try {
      return await this.trpcPost('GetSessionList', req);
    } catch (e) {
      logger.error('getSessionList e:', e);
      return {};
    }
  }

  /**
   * 获取最近一次分析结果
   */
  public async getLatestAnalysis(req: IGetLatestAnalysisReq): Promise<IGetLatestAnalysisRsp> {
    try {
      return await this.trpcPost('GetLatestAnalysis', req);
    } catch (e) {
      logger.error('GetLatestAnalysis e:', e);
      return {};
    }
  }
}

export const aiCopilotServer = new AiCopilotServer();
